import { Navigate, useLocation } from 'react-router-dom';

/** Legacy AppSumo URL → signup with OAuth code preserved in query string. */
const AppSumoActivateRedirect = () => {
	const location = useLocation();
	const params = new URLSearchParams(location.search);
	if (!params.get('utm_source')) {
		params.set('utm_source', 'appsumo');
	}
	const search = params.toString();
	return <Navigate to={`/signup${search ? `?${search}` : ''}`} replace />;
};

export default AppSumoActivateRedirect;
